(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // View More / View Less Logic
  document.addEventListener('DOMContentLoaded', function() {
    const descriptionContainer = document.getElementById('medical-description-content');
    const viewMoreBtn = document.getElementById('view-more-btn');

    if (descriptionContainer && viewMoreBtn) {
      if (descriptionContainer.scrollHeight <= 100) {
        viewMoreBtn.style.display = 'none';
        descriptionContainer.classList.add('no-fade');
      }

      viewMoreBtn.addEventListener('click', function() {
        if (descriptionContainer.classList.contains('expanded')) {
          descriptionContainer.classList.remove('expanded');
          viewMoreBtn.textContent = 'View More';
        } else {
          descriptionContainer.classList.add('expanded');
          viewMoreBtn.textContent = 'View Less';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
